export default "__VITE_ASSET__BZgpjKkZ__"